import React from "react";
import Icons from "components/icons";
import { Localize } from "components/service";
import { getStaffAuditScanLocation } from "../helpers/staff-audit-log-presentation-helper";


const StaffAuditScanLocationField = ({ auditLog, onOpenLocation }) => {
    const location = getStaffAuditScanLocation(auditLog);

    if (!location)
    {
        return (
            <span className="staff-audit-scan-location staff-audit-scan-location--empty">
                <span className="d-flex align-items-center justify-content-center staff-audit-scan-location__icon" aria-hidden="true">
                    <Icons.StaffLocationMap />
                </span>
                <Localize>STAFF_MANAGEMENT.Text_NoLocation</Localize>
            </span>
        );
    }

    return (
        <button
            type="button"
            className="btn-text-link staff-audit-scan-location staff-audit-scan-location--view"
            onClick={ () => onOpenLocation(location) }>
            <span className="d-flex align-items-center justify-content-center staff-audit-scan-location__icon" aria-hidden="true">
                <Icons.StaffLocationMap />
            </span>
            <span className="staff-audit-scan-location__label">
                <Localize>STAFF_MANAGEMENT.Action_View</Localize>
            </span>
        </button>
    );
};

export default StaffAuditScanLocationField;
